import { useEffect, useRef, useState } from "react";
import TaskFilterData from "../../pages/Tasks/components/TaskFilterData";
import { initialTaskFilterData } from "../../utils/initialData";
import { countNonMatchingEntries, handleDropdownClose } from "../../utils/utils";
import RightModal from "../Modal/RightModal";
import SavedFilterComponent from "../SavedFilters/SavedFilterComponent";

const TaskFilter = ({ filterData, onSetFilterData, onCallApiAgain }) => {
  const dropdownRef = useRef(null);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [selectedSavefilterId, setSelectedSaveFilterId] = useState(() => {
    const id = localStorage.getItem("selectedSavefilterId");
    return id ? id : "";
  });

  const count = countNonMatchingEntries(filterData, initialTaskFilterData);

  useEffect(() => {
    const handleClose = () => {
      setIsSidebarOpen(false);
    };
    handleDropdownClose(dropdownRef, handleClose);
  }, []);

  const handleFilter = () => {
    localStorage.setItem("TaskfilterData", JSON.stringify(filterData));
    onCallApiAgain();
    setIsSidebarOpen(false);
    setSelectedSaveFilterId("");
  };

  const handleSelectFilter = (value) => {
    const dataToSet = {
      selectedPriorities: value?.priority ?? [],
      selectedTaskTypes: value?.task_type ?? [],
      selectedLinkedOptions: value?.linked_to ?? [],
      isRepeatingTask: value?.repeating_tasks ?? "",
      selectedDueDate: value?.due_date ?? "",
      start_date: value?.start_date ?? "",
      end_date: value?.end_date ?? "",
    };
    localStorage.setItem("filterData", JSON.stringify(dataToSet));
    onSetFilterData(dataToSet);
    onCallApiAgain(dataToSet);
  };

  const saveSearchFilterData = {
    task_type: filterData?.selectedTaskTypes,
    priority: filterData?.selectedPriorities,
    linked_to: filterData?.selectedLinkedOptions,
    repeating_tasks: filterData?.isRepeatingTask,
    due_date: filterData?.selectedDueDate,
    start_date: filterData?.start_date,
    end_date: filterData?.end_date ?? "",
  };

  return (
    <div>
      <SavedFilterComponent
        from="task"
        count={count}
        isSidebarOpen={isSidebarOpen}
        saveSearchFilterData={saveSearchFilterData}
        selectedSavefilterId={selectedSavefilterId}
        initialFilterData={initialTaskFilterData}
        onCallApiAgain={onCallApiAgain}
        onSetFilterData={onSetFilterData}
        onSetSelectedSaveFilterId={(value) => {
          setSelectedSaveFilterId(value);
        }}
        handleSelectFilter={handleSelectFilter}
        onSetIsSidebarOpen={(value) => setIsSidebarOpen(value)}
      />

      <RightModal
        isOpen={isSidebarOpen}
        onClose={() => {
          setIsSidebarOpen(false);
        }}
        ref={dropdownRef}
        title={"Filter"}
        desc={"Enter Task information."}
        onFilter={handleFilter}
        from="task"
        saveSearchFilterData={saveSearchFilterData}
        onSetSelectedSaveFilterId={(value) => setSelectedSaveFilterId(value)}
      >
        <TaskFilterData isSidebarOpen={isSidebarOpen} filterData={filterData} onSetFilterData={onSetFilterData} />
      </RightModal>
    </div>
  );
};

export default TaskFilter;
